<template>
  <d-card class="card-small">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }} {{ statusLabels[filter] }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="p-0">

      <!-- Top Referrals List Group -->
      <d-list-group flush class="list-group-small">
        <d-list-group-item v-for="(item, idx) in referralData" :key="idx" class="d-flex px-3">
          <d-link class="link" >
            <span class="text-semibold text-fiord-blue">{{ item.reference_no }} </span>
            <span class="text-semibold text-fiord-blue"> {{ item.customer_name }} </span>
          </d-link>
          <span class="ml-auto text-right text-semibold text-reagent-gray">{{ item.total }}</span>
        </d-list-group-item>
        <d-list-group-item v-if="referralData.length === 0"  class="d-flex px-3 no-content">
          {{ $t('shared.dashboard.noResults') }}
        </d-list-group-item>
      </d-list-group>

    </d-card-body>

    <d-card-footer class="border-top">
      <d-row>

        <!-- Time Frame -->
        <d-col>
          <d-select size="sm" v-model="filter" style="max-width: 150px;" :options="status" >
          </d-select>
        </d-col>

        <!-- View Full Report -->
        <d-col class="text-right view-report">
          <d-link class="link">{{ $t('shared.dashboard.viewAll') }}</d-link>
        </d-col>

      </d-row>
    </d-card-footer>

  </d-card>
</template>

<script>

export default {
  name: 'dashboard-last-register',
  data() {
    return {
      filter: 'pending',
      referralData: [],
    };
  },
  computed: {
    title() {
      return this.$t('shared.dashboard.statusRegisters.title');
    },
    statusLabels() {
      return {
        open: this.$t('shared.dashboard.status.open'),
        pending: this.$t('shared.dashboard.status.pending'),
        approved: this.$t('shared.dashboard.status.approved'),
        canceled: this.$t('shared.dashboard.status.canceled'),
        closed: this.$t('shared.dashboard.status.closed'),
      };
    },
    status() {
      return [
        { value: 'open', text: this.statusLabels.open },
        { value: 'pending', text: this.statusLabels.pending },
        { value: 'approved', text: this.statusLabels.approved },
        { value: 'canceled', text: this.statusLabels.canceled },
        { value: 'closed', text: this.statusLabels.closed },
      ];
    },
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  cursor: pointer;
}
</style>
